import { render } from "./TeamMixin.vue?vue&type=template&id=4a1da0b6"
import script from "./TeamMixin.vue?vue&type=script&lang=js"
export * from "./TeamMixin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__